import { helpers } from "@vuelidate/validators";
import unique from "./unique";
import { fieldRules } from "./validationFieldRules";
import { sameAsEmail } from "./validationCustomValidators";

export const extendApplicantCreator =
  (extend = {}) =>
  (presets = {}) => ({
    id: unique(),
    FirstName: "",
    LastName: "",
    Ssn: "",
    Address: "",
    PostalCode: "",
    City: "",
    usePrimaryApplicantAddress: false,
    Phone: "",
    PhoneCountryCode: "+358",
    ContactLanguage: "fi",
    Email: "",
    emailAgain: "",
    MarketingAllowed: false,
    ...extend,
    ...presets,
  });

export const validations = {
  applicant: {
    FirstName: fieldRules.FirstName,
    LastName: fieldRules.LastName,
    Ssn: fieldRules.Ssn,
    Address: fieldRules.Address,
    PostalCode: fieldRules.PostalCode,
    City: fieldRules.City,
    usePrimaryApplicantAddress: fieldRules.usePrimaryApplicantAddress,
    Phone: fieldRules.Phone,
    PhoneCountryCode: fieldRules.PhoneCountryCode,
    ContactLanguage: fieldRules.ContactLanguage,
    Email: fieldRules.Email,
    emailAgain: {
      sameAs: sameAsEmail,
    },
    MarketingAllowed: fieldRules.MarketingAllowed,
  },
  form: {
    OtherResidents: {
      $each: helpers.forEach({
        FirstName: fieldRules.FirstName,
        LastName: fieldRules.LastName,
        Ssn: fieldRules.Ssn,
      }),
    },
  },
};
